import instance from './base';

// 查詢寄信紀錄。僅 admin 可用（後端 permission_required STAFF_ROLE_ADMIN）。
// params：recipient / subject（模糊）、email_type / status（逗號分隔多值）、
//         reference_type / reference_id、start_at / end_at（秒級 timestamp）、
//         page（0 起算）/ limit（預設 100）
// 回傳 { meta: { total, page, limit }, email_logs: [...] }
export async function getEmailLogs(params) {
  const rsp = await instance.get('/v1/log/email', { params });
  return rsp.data;
}

// 取得搜尋介面用的 email_type / status 選項
// 回傳 { email_types: [...], statuses: [...] }
export async function getEmailLogCatalog() {
  const rsp = await instance.get('/v1/log/email/catalog');
  return rsp.data;
}
